import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  Menu list filter
export const MenuListFilter = createSlice({
  name: "MenuListFilter",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_MenuListFilter: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_MenuListFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_MenuListFilter: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    MenuListFilter_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearMenuListFilter: (state) => {
      state.data = [];
    },
  },
});
export default MenuListFilter.reducer;
export const {
  list_MenuListFilter,
  success_api_call_MenuListFilter,
  failure_api_call_MenuListFilter,
  MenuListFilter_is_first,
  clearMenuListFilter,
} = MenuListFilter.actions;
